import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    homeRedirect: false,
    applications: [],
    profile: false,
    application: false
  },
  mutations: {
    SAVE_HOME_REDIRECT(state, val) {
      state.homeRedirect = val;
    },
    SAVE_APPLICATIONS(state, applications) {
      state.applications = (Array.isArray(applications)
        ? applications
        : []
      ).filter(e => e.id !== process.env.VUE_APP_ID);
      const app = applications.filter(e => e.id === process.env.VUE_APP_ID)[0];
      state.application = app;
    },
    SAVE_USER_PROFILE(state, profile) {
      state.profile = profile;
    }
  },
  actions: {
    loadApplications({ commit }) {
      this.$api
        .get("/applications", { sailent: true })
        .then(res => {
          const app = res.result.filter(a => a.id === process.env.VUE_APP_ID);
          if (app.length === 0) {
            commit("SAVE_HOME_REDIRECT", true);
          }
          commit("SAVE_APPLICATIONS", res.result);
        })
        .catch(error => {
          error;
        });
    },
    loadProfile({ commit }) {
      this.$api.get("/profile").then(res => {
        commit("SAVE_USER_PROFILE", res.result || false);
      });
    }
  },
  modules: {}
});
